export default __webpack_public_path__ + "static/momo-6e4c7b7cd78d6c23fcae09e95b2bffec.png";